import { render, staticRenderFns } from "./Ware.vue?vue&type=template&id=8816d1d6&scoped=true&"
import script from "./Ware.vue?vue&type=script&lang=js&"
export * from "./Ware.vue?vue&type=script&lang=js&"
import style0 from "./Ware.vue?vue&type=style&index=0&id=8816d1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8816d1d6",
  null
  
)

export default component.exports